import { Box, Typography } from '@mui/material';
import { colorsFoundation } from '../tokens/colors-foundation.js';
import { typographyTokens } from '../tokens/typography.js';
import { dimensions } from '../tokens/dimensions.js';
import VersionText from './VersionText.jsx';

/**
 * Footer for authentication pages
 * Displays product/version text centered at the bottom of the screen
 *
 * @param {object} props
 * @param {object} props.sx - Additional MUI sx styles
 */
export default function AuthFooter
({
    sx = {}
})
{
    return (
        <Box
            component="footer"
            sx={{
                position: 'absolute',
                bottom: dimensions['3xl'],
                left: 0,
                right: 0,
                display: 'flex',
                justifyContent: 'center',
                px: dimensions['3xl'],
                ...sx
            }}
        >
            <Typography
                variant="body2"
                sx={{
                    color: colorsFoundation.neutral.white,
                    fontFamily: typographyTokens.family.body,
                    textAlign: 'center'
                }}
            >
                <VersionText />
            </Typography>
        </Box>
    );
}
